import React, { useEffect, useRef } from "react";
import { addBaseMap } from "../lib/mapBase";
import { addMapLock } from "../lib/mapLock";
import { createPortal } from "react-dom";

export const AmbarMap = ({ a, onClose }) => {
  const ref = useRef(null);
  useEffect(() => {
    const L = window.L; if (!L || !ref.current) return;
    const map = L.map(ref.current, { center: [39, 35], zoom: 6 });
    addMapLock(map, "ambar");
    addBaseMap(map, "ambar");
    const set = new Set(a.iller || []);
    fetch("/tr-iller.json").then((r) => r.json()).then((g) => {
      if (!map._loaded) return;
      L.geoJSON(g, { style: (f) => { const il = String(f.properties.name).toLocaleUpperCase("tr-TR"); const on = set.has(il), mer = il === a.merkez_il;
        return { color: "#fff", weight: 1, fillColor: mer ? "#ea580c" : on ? "#2563eb" : "#e2e8f0", fillOpacity: mer || on ? 0.6 : 0.25 }; },
        onEachFeature: (f, l) => l.bindTooltip(String(f.properties.name).toLocaleUpperCase("tr-TR"), { sticky: true }) }).addTo(map);
    }).catch(() => {});
    const t = setTimeout(() => map.invalidateSize(), 300);
    return () => { clearTimeout(t); map.remove(); };
  }, [a]);
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/60 p-3 pt-12" onClick={onClose}>
      <div data-testid="ambar-map-dialog" className="w-full max-w-5xl space-y-2 rounded-xl border border-slate-700 bg-slate-900 p-3 text-slate-100" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 text-sm font-bold">{a.ad} · HİZMET VERDİĞİ İLLER ({(a.iller || []).length})
          <span className="text-[11px] font-normal text-slate-400"><b className="text-orange-500">■</b> MERKEZ {a.merkez_il} · <b className="text-blue-500">■</b> HİZMET İLLERİ</span>
          <button data-testid="ambar-map-close" onClick={onClose} className="ml-auto rounded bg-slate-700 px-2 py-0.5 text-xs">KAPAT ×</button></div>
        <div ref={ref} data-testid="ambar-map" className="h-[55vh] w-full rounded-lg" />
        <div className="flex flex-wrap gap-1">{(a.iller || []).map((x) => <span key={x} className="rounded-full bg-blue-600 px-2 py-0.5 text-[11px] font-semibold text-white">{x}</span>)}</div>
        <div className="text-xs text-slate-300">{[a.yetkili, a.gsm, a.tel, a.email, a.merkez_adres, a.merkez_ilce, a.merkez_il].filter(Boolean).join(" · ")}</div>
      </div>
    </div>, document.body
  );
};
